export default "__VITE_ASSET__BuLO$hXo__"